import { Component, Input } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import Product from 'src/app/model/product/product';
import ProductPhoneNumber from 'src/app/model/product/product-phone-number';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'client-product-phone-number-selector',
  templateUrl: './client-product-phone-number-selector.component.html',
  styleUrls: ['./client-product-phone-number-selector.component.scss'],
  providers: [FormatPhoneNumber]
})
export class ClientProductPhoneNumberSelectorComponent extends SubscriptionBasedComponent {
  @Input()
  inputProduct: Product;
  @Input()
  inputProjectContact: ProjectContact;

  init = false;
  numbers: string[];
  productPhoneNumber: ProductPhoneNumber;
  alternateProductPhoneNumber: ProductPhoneNumber;
  alternateProductPhoneNumberInArray = false;
  displayProjectContact: string;

  constructor(
    public formatPhoneNumber: FormatPhoneNumber,
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    this.calculateDisplayProjectContact();
    this.getPhoneNumbers();
    if (this.inputProduct.productPhoneNumbers == null) {
      this.inputProduct.productPhoneNumbers = [];
    }
    this.inputProduct.productPhoneNumbers.forEach(ppn => {
      if (
        this.numbers.includes(ppn.phoneNumbers) ||
        ppn.phoneNumbers === 'Geen'
      ) {
        this.productPhoneNumber = ppn;
      } else if (ppn.projectContact != null) {
        this.alternateProductPhoneNumber = ppn;
        this.alternateProductPhoneNumberInArray = true;
      }
    });
    this.alternateProductPhoneNumber =
      this.alternateProductPhoneNumber == null
        ? new ProductPhoneNumber()
        : this.alternateProductPhoneNumber;
    if (this.productPhoneNumber == null) {
      // find product phone number in array that is not the alternateProductPhoneNumber
      for (let ppn of this.inputProduct.productPhoneNumbers) {
        if (ppn != this.alternateProductPhoneNumber) {
          this.productPhoneNumber = ppn;
          break;
        }
      }
      // if productPhoneNumber still not set, create new and add it to array
      if (this.productPhoneNumber == null) {
        this.productPhoneNumber = new ProductPhoneNumber();
        this.inputProduct.productPhoneNumbers.push(this.productPhoneNumber);
      }
    }
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateDisplayProjectContact();
      }
    );
    this.init = true;
  }

  getPhoneNumbers() {
    this.numbers = ['Geen'];
    for (let phoneObject of this.inputProjectContact.contact.telephones) {
      this.numbers.push(phoneObject.number);
    }
    for (let phoneObject of this.inputProjectContact.company.telephones) {
      this.numbers.push(phoneObject.number);
    }
  }

  productPhoneNumberChange(event) {
    this.productPhoneNumber.phoneNumbers = event;
    this.projectDisplayObservableService
      .getProductPhoneNumberChangedSubscribable()
      .next();
  }

  alternateProductPhoneNumberChange(number: string) {
    if (number != null) {
      this.alternateProductPhoneNumber.phoneNumbers = this.formatPhoneNumber.transform(
        number
      );
      if (
        this.alternateProductPhoneNumberInArray &&
        (this.alternateProductPhoneNumber.phoneNumbers == null ||
          this.alternateProductPhoneNumber.phoneNumbers === '')
      ) {
        let index = this.inputProduct.productPhoneNumbers.indexOf(
          this.alternateProductPhoneNumber
        );
        this.inputProduct.productPhoneNumbers.splice(index, 1);
        this.alternateProductPhoneNumberInArray = false;
      }
      if (
        !this.alternateProductPhoneNumberInArray &&
        this.alternateProductPhoneNumber.phoneNumbers != null &&
        this.alternateProductPhoneNumber.phoneNumbers !== ''
      ) {
        this.inputProduct.productPhoneNumbers.push(
          this.alternateProductPhoneNumber
        );
        this.alternateProductPhoneNumberInArray = true;
      }
      this.projectDisplayObservableService
        .getProductPhoneNumberChangedSubscribable()
        .next();
    }
  }

  calculateDisplayProjectContact() {
    this.displayProjectContact =
      StringHelper.join(
        [
          this.inputProjectContact.contact == null
            ? null
            : this.inputProjectContact.contact.firstName,
          this.inputProjectContact.contact == null
            ? null
            : this.inputProjectContact.contact.lastName
        ],
        ' '
      ) +
      ' (' +
      (this.inputProjectContact.company == null
        ? ''
        : this.inputProjectContact.company.regularName) +
      ')';
  }
}
